import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { MInput } from '../../Input/index';
import '../../../assets/styles/global.scss';
import '../styles/searchBar.scss';
import validators from '../../../utils/validators';
function SearchQty(props) {
    const [minQty, setMinQty] = useState(null);
    const [maxQty, setMaxQty] = useState(null);
    const [enableBtn, setEnableBtn] = useState(true);
    const { show, minQtyP, maxQtyP } = props;
    useEffect(() => {
        if (minQtyP !== minQty) setMinQty(minQtyP);
        if (maxQtyP !== maxQty) setMaxQty(maxQtyP);
        return () => {
            setMinQty(null);
            setMaxQty(null);
        }
    }, [minQtyP, maxQtyP]);

    useEffect(() => {
        setMinQty(minQtyP);
        setMaxQty(maxQtyP);
    }, [show]);

    useEffect(() => {

        if (minQty && minQty.length > 0 && maxQty && maxQty.length > 0 && !validators.containCharacters(minQty) &&
            !validators.containCharacters(maxQty))
            setEnableBtn(false);
        else
            setEnableBtn(true);
    }, [minQty, maxQty]);
    return (
        <>
            {show && (
                <>
                    <div className="search-bar-input-section flex">
                        <div className="width-198-px p-r-5">
                            <MInput label="Min Qty" full={minQty} handleChange={event => setMinQty(event.target.value)}
                                helperText={(minQty && validators.containCharacters(minQty)) && ' *Only numbers are allowed'}
                            />
                        </div>

                        <div className="width-198-px p-l-rWidth={true} value-5">
                            <MInput label="Max Qty" fullWidth={true} value={maxQty} handleChange={event => setMaxQty(event.target.value)}
                                helperText={(maxQty && validators.containCharacters(maxQty)) && ' *Only numbers are allowed'}
                            />
                        </div>
                    </div>
                    <div className="button-section">
                        <Button className="button-grey m-r-12" onClick={() => {
                            if (props.minQty || props.maxQty) {
                                setMinQty(null);
                                setMaxQty(null);
                                props.setParent({
                                    minQty: null,
                                    maxQty: null
                                });
                            }
                            props.closeFilter();
                        }}>Clear</Button>
                        <Button className="button-green" disabled={enableBtn} onClick={() => {
                            props.setParent({
                                minQty: minQty,
                                maxQty: maxQty
                            });
                            props.closeFilter();
                        }}>Apply</Button>
                    </div>
                </>
            )}
        </>
    );
}

export default SearchQty;